export const it = {
  homePage: {
    helloWorld: 'Hi, how you doin?',
    countable: 'no count | one count | 2nd thing | {count} thingy',
    variablesOne: 'First var: {0}, Second var: {1}'
  },
  'homePage.variablesTwo': 'First var: {one}, Second var: {two}',
  nav: {
    model: 'Modelli',
    details: 'Dettagli',
    summary: 'Conclusione',
    preview: 'Anteprima',
  },
  footer:{
    total: 'Totale: {price} (IVA esclusa)',
    next: 'Avanti',
    submit: 'A pagamento',
    finish: 'Invia la richiesta',
    back: 'Di ritorno'
  },
  model: {
    selectModel: 'Seleziona un modello'
  },
  details: {
    editItem: 'Disegna la tua sedia',
    tooltip: `Il materiale selezionato è disponibile solo su richiesta. <br />  <br /> Ti invitiamo a vedere i campioni al link <a href="https://vez-sedezi.si/it/opzioni/" target="#" class="underline">https://vez-sedezi.si/it/opzioni/</a> e contattarci per selezionare insieme l'opzione migliore per te.`,
    tooltipOk: 'OK',
    noBackrestUpholstery: 'Senza schienale imbottito',
    backrest: 'Schienale',
    upholstered: 'Imbottitura',
    notUpholstered: 'Senza imbottitura',
    options: 'nessuna opzione | 1 opzione| {options} opzioni',
    loadingModel: 'Disegno in corso...',
    colorWarning: 'I modelli di colore sul computer potrebbero essere differenti dalla situazione reale.'
  },
  maps: {
    bugy: {
      legs: 'Gambe',
      seat: 'Seduta',
      seatingAndBackrest: 'Imbottitura'
    },
    barly: {
      legs: 'Gambe',
      seat: 'Seduta',
      seatingAndBackrest: 'Imbottitura'
    },
    barman: {
      seat: 'Seduta',
      seatingAndBackrest: 'Imbottitura'
    },
    kuki: {
      legs: 'Gambe',
      seat: 'Seduta',
      seatingAndBackrest: 'Imbottitura'
    },
    praktik: {
      seat: 'Seduta',
      seatingAndBackrest: 'Imbottitura'
    },
    scorpio: {
      legs: 'Gambe',
      seat: 'Seduta',
      seatingAndBackrest: 'Imbottitura',
      legsShape: 'Forma delle gambe'
    }
  },
  summary: {
    summary: 'Conclusione',
    send_inquiry: 'Invia una richiesta',
    message: 'È anche possibile acquistare una sedia singola. Se i tuoi desideri sono diversi, il prezzo cambia a seconda della scelta dei materiali e della quantità. Aggiungi i tuoi desideri nel commento.',
    remove: 'Rimuovi',
    edit: 'Modifica',
    duplicate: 'Duplica',
    addNewProduct: 'Aggiungi una nuova sedia',
    card: {
      pricePerItem: '{price} / sedia (IVA esclusa)'
    }
  },
  preview: {
    summary: 'Guardare',
    vatBasis: 'base IVA',
    vat: 'IVA',
    totalPrice: 'Totale',
    yourInfo: 'I tuoi dati',
    delivery: 'Consegna',
    freeDelivery: 'Previo accordo.',
    payment: 'Pagamento',
    price: {
      free: 'Consegna gratuita',
      formatted: '{price}'
    },
  },
  done: {
    thankYou: 'Grazie per la fiducia!',
    done1: 'Abbiamo accettato la tua richiesta.',
    done2: 'Vuoi saperne di più sulle sedie Vez personalizzate?',
    done3: 'Ti invitiamo a visitare il nostro sito web.',
    back: 'Avanti al sito web'
  },
  inputs: {
    comment: 'Commenti',
    firstName: 'Nome',
    lastName: 'Cognome',
    phone: 'Numero di telefono',
    mail: 'E-mail',
    address: 'Indirizzo',
    post: 'Codice postale',
    city: 'Città',
    businessReceipt: 'Fattura aziendale',
    taxId: 'IVA',
    company: `Denominazione dell'impresa`
  },
  errors: {
    firstName: 'Il nome è obbligatorio',
    firstNameLength: 'Il nome deve contenere almeno {length} caratteri',
    lastName: 'Il cognome è obbligatorio',
    lastNameLength: 'Il cognome deve contenere almeno {length} caratteri',
    phone: 'Il numero di telefono è obbligatorio',
    phoneValid: 'Il numero di telefono non è nel formato corretto',
    mail: `L'email è obbligatoria`,
    mailValid: `L'email non è valida`,
    address: `L'indirizzo è obbligatorio`,
    post: 'Il codice postale è obbligatorio',
    city: 'La città è obbligatoria',
    taxId: 'La partita IVA è obbligatoria',
    company: 'Il nome dell\'azienda è obbligatorio',
    delivery: 'La consegna è obbligatoria'
  },
  payment:{
    later: 'Basta chiedere',
    now: 'Voglio pagare adesso'
  }

};

export const currencyItIT = {
  currency: {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'symbol'
  }
}
